import React from 'react';
import styled from 'styled-components';
import DatePicker from './DatePicker';
import qbSignal from './signal';
import { IDatePickerValue } from 'components/DatePicker';
import { Select } from 'antd';
import toast from 'utils/toast';
import TimeSlotAvailablePicker from 'widgets/Staff/TimeSlotAvailablePicker';

const durations = [
  { label: '15 minutes', value: 15 },
  { label: '30 minutes', value: 30 },
  { label: '45 minutes', value: 45 },
  { label: '1 hour', value: 60 },
  { label: '1.5 hours', value: 90 },
  { label: '2 hours', value: 120 },
  { label: '2.5 hours', value: 150 },
  { label: '3 hours', value: 180 },
  { label: '3.5 hours', value: 210 },
  { label: '4 hours', value: 240 },
  { label: '5 hours', value: 300 },
  { label: '6 hours', value: 360 },
  { label: '7 hours', value: 420 },
  { label: '8 hours', value: 480 },
  { label: '9 hours', value: 540 },
];

const TimeSection = () => {
  const setCurrentDate = (date: IDatePickerValue) => {
    qbSignal.currentDate.value = date;
  };
  const handleChangeDuration = (value: number) => {
    qbSignal.duration.value = value;
  };

  /**
   * Popup timeslot tra ve khung gio trong cua mot staff cu the. Chua chon staff thi request se
   * di voi `staffId` rong va tra ve du lieu vo nghia — chan tu day thay vi de server tu xu ly.
   */
  const getSelectedStaffId = () => {
    const staffId = qbSignal.staffs.value?.[0];
    if (!staffId) {
      toast.info('Please add staff first');
      return null;
    }
    return staffId;
  };

  const handleChangeDate = async (date: IDatePickerValue) => {
    const staffId = getSelectedStaffId();
    if (!staffId) return;
    const dateTimeslot = await TimeSlotAvailablePicker.get(staffId, date);
    if (!dateTimeslot) return;
    setCurrentDate(dateTimeslot);
    qbSignal.currentDate.value = dateTimeslot;
    qbSignal.startTime.value = dateTimeslot.format('hh:mm A');
  };

  const onChangeStartTime = async () => {
    const staffId = getSelectedStaffId();
    if (!staffId) return;
    const dateTimeslot = await TimeSlotAvailablePicker.get(staffId, qbSignal.currentDate.value);
    if (!dateTimeslot) return;
    qbSignal.startTime.value = dateTimeslot.format('hh:mm A');
  };

  return (
    <TimeContainer className='section-wrapper'>
      <div className='time-picker-item'>
        <div className="section-label">DATE</div>
        <DatePicker
          value={qbSignal.currentDate.value}
          onChange={handleChangeDate}
        />
      </div>
      <div className='time-picker-item'>
        <div className="section-label">START TIME</div>
        <StartTimeButton type='button' onClick={onChangeStartTime}>
          <Select
            value={qbSignal.startTime.value}
            options={qbSignal.startTime.value ? [{ label: qbSignal.startTime.value, value: qbSignal.startTime.value }] : []}
            className='disabled-select'
          />
        </StartTimeButton>
      </div>
      <div className='time-picker-item'>
        <div className="section-label">DURATION</div>
        <Select
          value={qbSignal.duration.value}
          onChange={handleChangeDuration}
          options={durations}
        />
      </div>
    </TimeContainer>
  );
};

export default TimeSection;

const TimeContainer = styled.div`
  display: grid; 
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 24px;
  .time-picker-item {
    display: flex;
    flex-direction: column; 
    gap: 8px;
    .ant-select-single {
      width: 100%;
      height: 50px;
      .ant-select-selection-item {
        font-size: 22px;
      }
    }
    .WrapDateTime {
      height: 50px;
      .ant-picker .ant-picker-input >input {
        font-size: 22px;
        font-weight: 400;
      }
      input {
        font-size: 22px;
      }
    }
    &.ant-form-large .ant-form-item .ant-form-item-label>label {
      height: 24px;
    }
  }

`;

const StartTimeButton = styled.button`
.ant-select.disabled-select {
  pointer-events: none;
  .ant-select-selector .ant-select-selection-item {
    text-align: left;
  }
}
`;